import React from "react";
import { Dropdown, Text } from "basis";

import { Icon } from "../../components";
import { COUNTRY, GATEWAY_NAME } from "../../core/constants";

const GATEWAY_OPTIONS = [
  {
    data: {
      iconType: "latitudePay",
    },
    value: GATEWAY_NAME.LATITUDE_PAY,
    country: COUNTRY.AU,
  },
  {
    data: {
      iconType: "latitudeInterestFree",
    },
    value: GATEWAY_NAME.LATITUDE_INTEREST_FREE,
    country: COUNTRY.AU,
  },
  {
    data: {
      iconType: "genoaPay",
    },
    value: GATEWAY_NAME.GENOA_PAY,
    country: COUNTRY.NZ,
  },
  {
    data: {
      iconType: "gemInterestFree",
    },
    value: GATEWAY_NAME.GEM_INTEREST_FREE,
    country: COUNTRY.NZ,
  },
];

const GatewayOption = ({ country, option }) => {
  const matchingOption = GATEWAY_OPTIONS.find(
    (curr) => curr.country === country && curr.value === option.value
  );

  const { iconType = "" } = matchingOption?.data || {};

  if (iconType.length < 1) {
    return <Text>Please select</Text>;
  }

  return <Icon size="120px" type={iconType} />;
};

const GatewayNameDropdown = ({
  name = "gatewayName",
  country = COUNTRY.AU,
}) => {
  const options = GATEWAY_OPTIONS.filter(
    (option) => option.country === country
  );

  return (
    <Dropdown
      name={name}
      label="Payment Method"
      color="white"
      options={options}
      optionToString={({ value }) => value}
      optionComponent={(option) => (
        <GatewayOption option={option} country={country} />
      )}
    />
  );
};

export default GatewayNameDropdown;